import { render, staticRenderFns } from "./cpuSummary.vue?vue&type=template&id=2a61ed22&scoped=true&"
import script from "./cpuSummary.vue?vue&type=script&lang=js&"
export * from "./cpuSummary.vue?vue&type=script&lang=js&"
import style0 from "./cpuSummary.vue?vue&type=style&index=0&id=2a61ed22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a61ed22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a61ed22')) {
      api.createRecord('2a61ed22', component.options)
    } else {
      api.reload('2a61ed22', component.options)
    }
    module.hot.accept("./cpuSummary.vue?vue&type=template&id=2a61ed22&scoped=true&", function () {
      api.rerender('2a61ed22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/cpuSummary.vue"
export default component.exports